import _ from 'lodash';
import * as React from 'react';
import { styled } from 'linaria/react';
import VisuallyHidden from '@reach/visually-hidden';
export const Button = /*#__PURE__*/styled(({
  innerRef,
  ...props
}) => {
  // todo - somehow share the "once keyboard-focused, ignore the visually hidden" logic?
  return <>
      <button aria-hidden ref={innerRef} {..._.omit(props, 'isShowing')}>
        Buy Now
      </button>
      <VisuallyHidden>
        <button {..._.omit(props, 'isShowing')}>
          Buy Now
        </button>
      </VisuallyHidden>
    </>;
})({
  name: "Button",
  class: "bvdu3q4",
  vars: {
    "bvdu3q4-0": [({
      isShowing
    }) => isShowing ? 'auto' : 'none'],
    "bvdu3q4-1": [({
      isShowing
    }) => isShowing ? 0.7 : 0]
  }
});

require("./BuyNow.linaria.module.css!=!../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./BuyNow.tsx");